import { isArray } from 'util';
import { HasMaintenanceTaskUserNotificationNotRead } from '../has-maintenance-task-notification-not-read';

export class HasMaintenanceTaskUserNotificationNotReadBuilder {
  static fromJson(json) {
    return (json)
      ? new HasMaintenanceTaskUserNotificationNotRead(
        json.hasNotify
      )
      : null;
  }

  static fromList(list) {
    return (isArray(list)) ? list.map(HasMaintenanceTaskUserNotificationNotReadBuilder.fromJson) : [];
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/has-maintenance-task-user-notification-not-read.builder.ts